module.exports = __webpack_public_path__ + "assets/shopping_cart_page_empty_state-3e6f17.svg";